import { render, staticRenderFns } from "./CabinetUser.vue?vue&type=template&id=18aa5d05"
import script from "./CabinetUser.vue?vue&type=script&lang=js"
export * from "./CabinetUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports